const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b;

interface Coords {
  x: number;
  y: number;
}

class Cursor {
  private target: Coords = { x: 0.5, y: 0.5 };
  private cursor: Coords = { x: 0.5, y: 0.5 };
  private speed: number = 0.2;
  private videoContainer: HTMLElement;
  private videoPlayer: HTMLElement | null;
  private raf: number | null = null;

  constructor(video: HTMLElement) {
    this.videoContainer = video;
    this.videoPlayer = document.querySelector<HTMLElement>(".control__play");
  }

  onMouseMove = (e: MouseEvent) => {
    //get normalized mouse coordinates [0, 1]
    this.target.x = e.clientX / this.videoContainer.offsetWidth;
    this.target.y = e.clientY / this.videoContainer.offsetHeight;
    // trigger loop if no loop is active
    if (!this.raf) this.raf = requestAnimationFrame(this.render);
  };

  render = () => {
    //calculate lerped values
    this.cursor.x = lerp(this.cursor.x, this.target.x, this.speed);
    this.cursor.y = lerp(this.cursor.y, this.target.y, this.speed);

    this.videoContainer.style.setProperty("--cursor-x", this.cursor.x.toString());
    this.videoContainer.style.setProperty("--cursor-y", this.cursor.y.toString());

    //cancel loop if mouse stops moving
    const delta = Math.sqrt(Math.pow(this.target.x - this.cursor.x, 2) + Math.pow(this.target.y - this.cursor.y, 2));

    if (delta < 0.001) {
      if (this.raf !== null) {
        cancelAnimationFrame(this.raf);
      }
      this.raf = null;
      return;
    }
    //or continue looping if mouse is moving
    this.raf = requestAnimationFrame(this.render);
  };

  init() {
    this.videoContainer.addEventListener("mousemove", this.onMouseMove);
    this.raf = requestAnimationFrame(this.render);
  }

  destroy() {
    if (this.raf !== null) {
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    this.videoContainer.style.setProperty("--cursor-x", "");
    this.videoContainer.style.setProperty("--cursor-y", "");
    this.videoContainer.removeEventListener("mousemove", this.onMouseMove);
  }
}

export function initCursor(): (() => Cursor | null) | void {
  const video = document.querySelector<HTMLElement>(".control__video");

  if (!video) return;

  const cursor = new Cursor(video);

  return function () {
    if (window.matchMedia("(min-width: 768px)").matches) {
      return cursor;
    }

    return null;
  };
}
